if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.productInventory = this.querySelector('.product-inventory');
      this.inventoryNotice = this.querySelector('.product-inventory__status');

      const product = this.closest('.js-product');

      if (product) {
        product.addEventListener(
          'on:variant:change',
          this.handleVariantChange.bind(this)
        );
      }
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return dataEl ? JSON.parse(dataEl.textContent) : [];
    }

    handleVariantChange(evt) {
      const variant = evt.detail.variant;
      const inventory = variant
        ? this.getVariantInventory().find(
          (entry) => String(entry.id) === String(variant.id)
        )
        : null;

      this.updateInventory(inventory);
    }

    updateInventory(inventory) {
      if (!inventory) {
        this.productInventory.hidden = true;
        return;
      }

      /*
       * Keeps the existing display working until the matching
       * Liquid markup is added in the next step.
       */
      if (!this.dataset.textBackorder) {
        const count = inventory.inventory_quantity;
        const threshold = Number(this.dataset.threshold);
        const lowStock = count <= threshold;

        const showCount = this.dataset.showInventoryCount === 'always'
          || (
            this.dataset.showInventoryCount === 'low'
            && lowStock
          );

        let notice;

        if (showCount) {
          notice = (
            lowStock
              ? this.dataset.textXLeftLow
              : this.dataset.textXLeftOk
          ).replace('[QTY]', count);
        } else {
          notice = lowStock
            ? this.dataset.textLow
            : this.dataset.textOk;
        }

        this.productInventory.classList.toggle(
          'product-inventory--low', lowStock
        );
        this.productInventory.classList.toggle(
          'product-inventory--ok', !lowStock
        );

        const lowIcon = this.querySelector('.product-inventory__icon-low');
        const okIcon = this.querySelector('.product-inventory__icon-ok');

        if (lowIcon) lowIcon.hidden = !lowStock;
        if (okIcon) okIcon.hidden = lowStock;

        this.inventoryNotice.textContent = notice;
        this.productInventory.hidden = false;
        return;
      }

      let state;

      if (!inventory.available) {
        state = 'soldout';
      } else if (
        inventory.inventory_management
        && inventory.inventory_quantity <= 0
        && inventory.inventory_policy === 'continue'
      ) {
        state = 'backorder';
      } else if (
        inventory.inventory_management
        && inventory.inventory_quantity > 0
      ) {
        state = 'instock';
      } else {
        // Untracked inventory does not prove physical stock.
        this.productInventory.hidden = true;
        return;
      }

      const messages = {
        instock: this.dataset.textOk,
        backorder: this.dataset.textBackorder,
        soldout: this.dataset.textSoldout
      };

      this.productInventory.dataset.stockState = state;
      this.inventoryNotice.textContent = messages[state];
      this.productInventory.hidden = false;
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
